export class TaskProgressionNotification {
	public ProgressValue: number;
	public ProgressText: string;
	public done: boolean;

	public static fromJson(other: any): TaskProgressionNotification {
		const instance = new TaskProgressionNotification();
		instance.ProgressValue = other.ProgressValue;
		instance.ProgressText = other.ProgressText;
		instance.done = other.Done;
		return instance;
	}
}
